
import { mapState, mapMutations } from "vuex";
import truncateString from '../../util/truncateString'
import { VueEllipsis } from 'vue-ellipsis-component';
import { _div } from "@/tool/index"

// game.crashPoint
export default {
	name: 'ui-game-sidebar',
	components: {
		VueEllipsis

	},

	filters: {

	},


	data() {
		return {
			asterisk: require('../../assets/asterisk.png'),
			device: require('../../assets/device1.png'),
			auto: require('../../assets/auto.png'),

			enterAutoCashout: [1.1, 2, 5, 10, 100],
			autoCashout: 1.5,
			isCheckCashout: false,
			betAmount: 0.25,
			autoBet: 0,
			isOpenDropdown: false,
			dropdownList: [0, 10, 25, 50, 100, 999],



			GAME_STATES: {
				NotStarted: 'NotStarted',
				Starting: 'Starting',
				InProgress: 'InProgress',
				Over: 'Over',
				Blocking: 'Blocking',
				Refunded: 'Refunded',
			}
		};
	},
	props: ['gameState', 'tick', 'ownBet', 'publicSeed', 'gameCountDownData', 'privateHash', 'enterAmount'],
	watch: {
		autoCashout(newValue, oldValue) {

			if (newValue > this.gameState.maxProfit) {
				localStorage.setItem("autoCashout", this.gameState.maxProfit);
				this.autoCashout = this.gameState.maxProfit
				return

			}
			localStorage.setItem("autoCashout", newValue);
		},
		betAmount(newValue, oldValue) {

			if (newValue > this.gameState.maxBetAmount) {
				localStorage.setItem("betAmount", this.gameState.maxBetAmount);
				this.betAmount = this.gameState.maxBetAmount
				return false

			}
			localStorage.setItem("betAmount", newValue);
		},
	},
	computed: {
		...mapState(["user"]),
		isJoined() {
			return !!this.ownBet;
		},
		isBtnDisable() {
			if (this.isJoined) {
				if(this.gameState.status != this.GAME_STATES.InProgress){
					return true;
				}
					
				if( this.ownBet.winningAmount){
					return true;
				}

			} else {
				if (this.gameState.status != this.GAME_STATES.Starting
					&& this.gameState.status != this.GAME_STATES.NotStarted) {
					return true;
				}
			}
			return false;
		},
		currencyType() {
			return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
		},
		currencyTypeLabel() {
			if (this.currencyType === 1) return '欢乐豆';
			if (this.currencyType === 2) return '金豆';
			return '现金';
		},
		currencyIcon() {
			if (this.currencyType === 1) return require('@/assets/images/home_new/currency_hld.png');
			if (this.currencyType === 2) return require('@/assets/images/home_new/jd_ico.png');
			return null;
		},
		allBalance() {
			if (this.currencyType === 1) return Number(this.user?.happyCoin || 0).toFixed(2);
			if (this.currencyType === 2) return Number(this.user?.coin1Available || 0).toFixed(2);
			return Number(this.user?.recycles || 0).toFixed(2);
		},

	},
	created() {
		this.init()
	},


	beforeDestroy() {
	},

	methods: {
		...mapMutations([

		]),

		changeAutoCashout() { // 输入倍数时
			// this.gameState.maxProfit 最大收益
			// this.autoCashout 倍率
			// this.betAmount 投注金额
			setTimeout(() => {

				if (this.autoCashout <= 1.05) {
					this.autoCashout = null
				}

				if (this.autoCashout && this.betAmount) {
					const maxBet = _div(this.gameState.maxProfit, this.autoCashout)
					if (this.betAmount > maxBet) {
						this.betAmount = maxBet
					}
				}
			}, 200)
		},
		changeBetAmount() { // 输入投注额时
			setTimeout(() => {
				if (this.autoCashout && this.betAmount) {
					const maxBet = _div(this.gameState.maxProfit, this.betAmount)
					if (this.autoCashout > maxBet) {
						this.autoCashout = maxBet
					}
				}
			}, 0)
		},

		init() {
			if (localStorage.getItem("enterAutoCashout")) {
				this.enterAutoCashout = JSON.parse(localStorage.getItem("enterAutoCashout"))
			}
			if (localStorage.getItem("autoCashout")) {
				this.autoCashout = localStorage.getItem("autoCashout")
			}
			if (localStorage.getItem("betAmount")) {
				this.betAmount = localStorage.getItem("betAmount")
			}

		},

		setAutoCashout(cashout) {
			this.autoCashout = cashout;
			this.changeAutoCashout()
		},

		isShowCheckCashout() {
			this.isCheckCashout = true
		},
		isCloseCheckCashout() {
			this.isCheckCashout = false
			localStorage.setItem("enterAutoCashout", JSON.stringify(this.enterAutoCashout));
		},

		setBetAmount(amount) {
			this.betAmount = amount;
			this.changeBetAmount()
		},
		setBetAmountMax() {
			this.betAmount = this.allBalance;
			this.changeBetAmount()
		},
		setAddBetAmount() {
			if (this.betAmount * 2 >= this.allBalance) {
				this.betAmount = this.allBalance
				return
			}

			this.betAmount = this.betAmount * 2
			this.changeBetAmount()
		},
		setMinusBetAmount() {
			// 1. 除以 2 后通过 toFixed(2) 强制保留两位小数，并转回 Number 防精度异常
			let newAmount = Number((Number(this.betAmount) / 2).toFixed(2));
			// 2. 边界判定与赋值
			if (newAmount <= 0.1) {
				this.betAmount = 0.1;
			} else {
				this.betAmount = newAmount;
			}
			// 3. 统一触发变更通知
			this.changeBetAmount();
		},

		setAutoBet(autoBet) {
			this.autoBet = autoBet;
			this.isOpenDropdown = false;
			this.$emit('handleStart')

		},

		setAutoBetMinus() {
			this.autoBet = this.autoBet - 1
		},

		clickBet() {
			// if (Date.now() - this.gameCountDownData.serverTimeStamp > 2000) {
			// 	this.$toast.error('网络不稳定，请autoplay');
			// 	return
			// }
			this.$emit('handleStart')
			setTimeout(() => {
				// 更新用户信息
				this.$store.commit('setInfo');
			}, 500)
		},
		clickCashout() {
			this.$emit('handleEnd')
			setTimeout(() => {
				// 更新用户信息
				this.$store.commit('setInfo');
			}, 500)
		},

		isShowOverlay() {
			this.$overlayModal.show()
		},

		toggleOpenDropdown() {
			this.isOpenDropdown = !this.isOpenDropdown
		},

		limitDecimalPlace(event, decimalPlace = 2) {
			let value = event.target.value;
			const decimalIndex = value.indexOf('.');

			// 如果包含小数点，且超出允许的小数位数
			if (decimalIndex !== -1 && value.length > decimalIndex + 1 + decimalPlace) {
				// 直接截断超出位数
				value = value.substring(0, decimalIndex + 1 + decimalPlace);
				event.target.value = value; // 同步更新输入框显示
			}

			this.betAmount = value;
			this.changeBetAmount();
		},

		truncateString,
		copyText() {
			this.$copyText(this.privateHash).then(
				e => {
					this.$toast.success("复制成功!");
				},
			)
		},
	},

}
